import { render, staticRenderFns } from "./WebsiteFAQ.vue?vue&type=template&id=3f61b642&scoped=true"
import script from "./WebsiteFAQ.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteFAQ.vue?vue&type=script&setup=true&lang=js"
import style0 from "./WebsiteFAQ.vue?vue&type=style&index=0&id=3f61b642&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61b642",
  null
  
)

export default component.exports